import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import Icon from 'flarum/common/components/Icon';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
import extractText from 'flarum/common/utils/extractText';
export default function addListStat() {
  extend(DiscussionListItem.prototype, 'statsItems', function (items) {
    const discussion = this.attrs.discussion;
    const count = discussion.wishVoteCount();

    // Every open wish shows its count, 0 included, so people see what still needs votes; closed ones only if voted.
    if (discussion.isOpenWish() || count > 0) {
      const label = abbreviateNumber(count);

      // Same markup as core's DiscussionListItemStatsItem. That class is a named export, and Flarum's runtime
      // registry only hands out a module's default export, so it cannot be imported here.
      items.add('wishVotes', m("span", {
        className: "DiscussionListItem-stats-item DiscussionListItem-wishVotes"
      }, m("span", {
        className: "DiscussionListItem-stats-item-icon"
      }, m(Icon, {
        name: app.forum.attribute('wishVotesIcon')
      })), m("span", {
        className: "DiscussionListItem-stats-item-label"
      }, m("span", {
        "aria-hidden": "true"
      }, label), m("span", {
        className: "visually-hidden"
      }, extractText(app.translator.trans('awaresoft-wish-votes.forum.list_count', {
        count
      }))))), 60);
    }
  });
}